<vl-form-grid mod-stacked>
	<vl-column v-if="error">
		<vl-alert icon="alert-circle" title="Onbekende fout" mod-error>
			<p>Er ging iets mis bij het ophalen van uw archiefpakket. Contacteer onze Helpdesk.</p>
		</vl-alert>
	</vl-column>
	<vl-column>
		<a :href="fileUrl" ref="downloadButton" :class="downloadButtonClasses">Download archiefpakket</a>
	</vl-column>
</vl-form-grid>